<template>
  <div>
    <v-card
      v-if="!showMobileView"
      class="ma-3 d-flex flex-column justify-center"
    >
      <div
        id="screen-uptime-chart"
        style="overflow:hidden;"
        class="d-flex justify-center"
      >
        <Chart
          type="gauge"
          :data="[_screenUptime]"
          :labels="data.chart.labels"
          title="Uptime"
          elevation="0"
          uptime="30 Days"
        />
      </div>
      <div
        class="d-flex justify-center"
        style="font-size:20px;"
        id="screen-uptime-days"
      >
        <h4>{{ getDays }}</h4>
      </div>
    </v-card>
    <div v-if="showMobileView">
      <Chart
        type="gauge"
        :data="[_screenUptime]"
        :labels="data.chart.labels"
        title="Uptime"
        elevation="0"
        uptime="30 Days"
        width="100%"
      />
      <div class="d-flex justify-center pb-8" style="font-size:20px;">
        <h4>{{ getDays }}</h4>
      </div>
    </div>
  </div>
</template>
<script>
import Chart from '@/components/charts/Chart';
import { MobileView } from '@/mixins';
import ScreenDetailData from '@/mixins/ScreenDetailData';

export default {
  mixins: [ScreenDetailData, MobileView],
  components: {
    Chart,
  },
  computed: {
    getDays() {
      const time = this._screenUptime * 0.01;
      const diff = 30 * time;
      const splitNum = diff
        .toFixed(1)
        .toString()
        .split('.');
      let hours = (splitNum[1] / 10) * 24;
      if (isNaN(hours)) {
        hours = 0;
      }
      return `${splitNum[0]} Days ${Math.round(hours)} Hours`;
    },
  },
};
</script>
